import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-list-text bg-gray-100 rounded-2 p-2 small text-gray-600 overflow-x-auto"></div>
`;

export class WCListText extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListText = clone.content.querySelector('.wc-list-text');
    contentNodes.forEach(node => {
      wcListText.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListText);
  }

}